module.exports = __webpack_public_path__ + "img/kefu.cd97a474.png";